module.exports = __webpack_public_path__ + "img/img10.21f7b080.svg";